'use client';
import { useEffect } from 'react';
import { startAppContext } from '@/lib/session/sessionCache';

/** Starts the shared app context once (single auth listener + 60s unread refresh). Renders nothing. */
export default function AppContextProvider() {
  useEffect(() => {
    startAppContext();
  }, []);
  return null;
}
